import { Label } from '../../ui/Label';
import { Switch } from '../../ui/Switch';
import { cn } from '@hero/web-lib';
import {
  FormFieldHelperIcon,
  type FormFieldHelperDisplay,
} from '../FormFieldCaption/FormFieldCaption';

export interface SettingSwitchRowProps {
  id: string;
  label: string;
  helper?: string;
  /** `icon` — tooltip on the label row; `text` — helper paragraph under the label. */
  helperDisplay?: FormFieldHelperDisplay;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Bordered settings row — label + optional helper on the start side,
 * switch on the end. Works in LTR and RTL via logical flex layout and
 * the shared {@link Switch} thumb mirroring.
 */
export function SettingSwitchRow({
  id,
  label,
  helper,
  helperDisplay = 'text',
  checked,
  onCheckedChange,
  disabled,
  className,
}: SettingSwitchRowProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-4 rounded-lg border border-border p-4',
        className,
      )}>
      <div className="min-w-0 flex-1">
        <div className="flex w-full items-center gap-1.5">
          <Label htmlFor={id} className="min-w-0">
            {label}
          </Label>
          {helper && helperDisplay === 'icon' ? (
            <FormFieldHelperIcon helper={helper} className="ms-auto" />
          ) : null}
        </div>
        {helper && helperDisplay === 'text' ? (
          <p className="mt-1 text-xs text-muted-foreground">{helper}</p>
        ) : null}
      </div>
      <Switch
        id={id}
        className="shrink-0"
        disabled={disabled}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
    </div>
  );
}
